import React from 'react';
import { Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

/**
 *
 */
class Layout_one extends Layout_base {
  render() {
    if (!this.shouldRender) {
      return null;
    }
    return (
      <Col xs={12}>
        {this.sectionHead()}
        {this.componentDOM(0)}
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_one;
